import { ApiPortfolioStatusFilter, ApiPortfolioType } from '..'

export interface QueryParams {
  FilterNewAccounts?: boolean
  PageNumber?: number
  PageSize?: number
  PortfolioStatusFilter?: ApiPortfolioStatusFilter
  PortfolioTypes?: ApiPortfolioType[]
  SortAscending?: boolean
  SortField?: string
  Status?: string
  WildcardString?: string
}

export const defaultQueryParams: QueryParams = {
  PageNumber: 1,
  PageSize: 1000,
  SortAscending: true
}
